/**
 * Validator for SkipLandmark action.
 *
 * Rules (§9.2, §11.1, §14):
 *   1. stateVersion matches.
 *   2. Phase is "unlockLandmark".
 *
 * Per §9.2: "SkipLandmark — also legal in unlockLandmark phase; advances
 * phase to endTurn with no landmark placed and no card chosen."
 *
 * No further checks are required.
 */

import type { SkipLandmarkAction } from "../types/actions";
import type { ValidationResult } from "../types/common";
import type { GameState } from "../types/game-state";
import { commonGuards, VALID } from "./common-guards";

export const validateSkipLandmark = (
  state: GameState,
  action: SkipLandmarkAction,
): ValidationResult => {
  const guard = commonGuards(state, action.stateVersion, "unlockLandmark");
  if (guard !== null) {
    return guard;
  }

  return VALID;
};
